import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { RentalAssortment } from '../components/RentalAssortment';
import { RentalSlider } from '../components/RentalSlider';
import { useScreenInit } from '../useScreenInit';
import { motion } from 'framer-motion';
export function RentalShop() {
  useScreenInit();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.8
  }} className="min-h-screen bg-white font-sans selection:bg-[#b22222] selection:text-white" data-id="element-509">
      <TopBar data-id="element-510" />
      <Navbar data-id="element-511" />
      <main className="py-20" data-id="element-512">
        <div className="mx-[4.1rem]" data-id="element-513">
          <div className="max-w-[1440px] mx-auto px-6" data-id="element-514">
            <h1 className="font-serif text-5xl mb-12" data-id="element-515">Rental Shop</h1>
            <RentalAssortment data-id="element-516" />
            <RentalSlider data-id="element-517" />
          </div>
        </div>
      </main>
    </motion.div>;
}